import React from 'react';
import { ChevronRight, Clock, RotateCcw, X } from 'lucide-react';
import { VersionHistory } from './VersionHistory';

interface VersionHistoryPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export function VersionHistoryPanel({ isOpen, onClose }: VersionHistoryPanelProps) {
  return (
    <div 
      className={`
        fixed right-0 top-0 h-full w-80 bg-gray-800 border-l border-gray-700
        transform transition-transform duration-200 ease-in-out
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}
      `}
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <div className="flex items-center gap-2 text-gray-100">
            <Clock className="w-5 h-5 text-indigo-400" />
            <h2 className="font-semibold">Version History</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-700 rounded-lg text-gray-400 hover:text-gray-300"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto">
          <VersionHistory />
        </div>
      </div>
    </div>
  );
}